module.exports = __webpack_public_path__ + "img/hr-brown-hairy-grass-04.53173c84.png";